<template>

  <div class="columns is-multiline is-mobile">
    <div class="column is-full-mobile">
      <window title="Basics" height="100%">
        <div class="field">
          <b-checkbox>Basic</b-checkbox>
        </div>
        <div class="field">
          <b-checkbox v-model="checkbox">
            {{ checkbox }}
          </b-checkbox>
        </div>
        <div class="field">
          <b-checkbox v-model="checkboxCustom" true-value="Yes" false-value="No">
            {{ checkboxCustom }}
          </b-checkbox>
        </div>
        <div class="field">
          <b-checkbox disabled>Disabled</b-checkbox>
        </div>
      </window>
    </div>
    <div class="column is-full-mobile">
      <window title="Multiselect" height="100%">
        <b-checkbox v-model="checkboxGroup2" native-value="Silver">
          Silver
        </b-checkbox>
        <b-checkbox v-model="checkboxGroup2" native-value="Flint">
          Flint
        </b-checkbox>
        <b-checkbox v-model="checkboxGroup2" native-value="Vane">
          Vane
        </b-checkbox>
        <b-checkbox v-model="checkboxGroup2" native-value="Billy" disabled>
          Billy
        </b-checkbox>
        <p class="content">
          <b>Selection:</b>
          {{ checkboxGroup2 }}
        </p>
      </window>
    </div>

    <div class="column is-full-mobile">
      <window title="Sizes" height="100%">
        <div class="field">
          <b-checkbox size="is-small">Small</b-checkbox>
        </div>
        <div class="field">
          <b-checkbox>Default</b-checkbox>
        </div>
        <div class="field">
          <b-checkbox size="is-medium">Medium</b-checkbox>
        </div>
        <div class="field">
          <b-checkbox size="is-large">Large</b-checkbox>
        </div>
      </window>
    </div>
    <div class="column is-full-mobile">
      <window title="Button style" height="100%">
        <b-field>
          <b-checkbox-button v-model="checkboxGroup" native-value="Nop" type="is-danger">
            <b-icon icon="close"></b-icon>
            <span>Nop</span>
          </b-checkbox-button>

          <b-checkbox-button v-model="checkboxGroup" native-value="Yep" type="is-success">
            <b-icon icon="check"></b-icon>
            <span>Yep</span>
          </b-checkbox-button>

          <b-checkbox-button v-model="checkboxGroup" native-value="Default">
            Default
          </b-checkbox-button>

          <b-checkbox-button v-model="checkboxGroup" native-value="Disabled" disabled>
            Disabled
          </b-checkbox-button>
        </b-field>
        <p class="content">
          <b>Selection:</b>
          {{ checkboxGroup }}
        </p>
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkbox: false,
      checkboxCustom: 'Yes',
      checkboxGroup2: ['Flint'],
      checkboxGroup: [],
    };
  },
};
</script>
